var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('v-header'),_c('v-logo'),_c('v-nav'),_c('v-breadcrumb'),_c('router-view',{staticClass:"router-view"}),_c('v-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }